import { FC, ReactNode } from 'react'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import { Col } from 'antd'
import PerText from '../../../components/custom_components/Text'
import '../pyramids.less'
import { PyramidsLegendItem } from './PyramidsLegendItem'
import { useTranslation } from 'react-i18next'
import { PyramidType } from '../../../types'
import { PyramidTabs, usePyramidsStore } from '../PyramidsStore'

interface Props {
  type: PyramidType
  graph: ReactNode
  overview?: ReactNode
}

export const PyramidsContentLayout: FC<Props> = ({ graph, overview, type }) => {
  const [t] = useTranslation()
  const activeTab = usePyramidsStore((state) => state.activeTab)

  return (
    <BackgroundBox r noPadding color="boxshadow">
      <PerFlexRow mb="xs">
        <Col span={24}>
          {overview && (
            <>
              <BackgroundBox noPadding mb="xxxs">
                <PerText appearance="tile-heading" mx="s" my="xs">
                  {t('pyramidsView.shared.overview.heading')}
                </PerText>
              </BackgroundBox>
              {overview}
              <div style={{ zIndex: 1 }} className="per-flexRow--growShrink">
                <BackgroundBox className="fullHeight" noShadow noPadding />
              </div>
            </>
          )}
        </Col>
      </PerFlexRow>
      <PerFlexRow>
        <Col span={14}>
          <BackgroundBox noShadow>
            <PerText appearance="tile-heading" mb="m">
              {t(`pyramidsView.shared.graph.heading.${type}`)}
            </PerText>
            <PerFlexRow justify="center" align="middle">
              {graph}
            </PerFlexRow>
          </BackgroundBox>
        </Col>
        <Col span={10}>
          <BackgroundBox className="fullHeight" noShadow>
            <PerFlexRow direction="column" justify="start">
              <PerText appearance="tile-heading" mb="m">
                {t('pyramidsView.shared.legend.heading')}
              </PerText>
              <PerFlexRow direction="column" align="top">
                <PyramidsLegendItem description={t('pyramidsView.shared.legend.past')} type="past" />
                <PyramidsLegendItem description={t('pyramidsView.shared.legend.current')} type="current" />
                <PyramidsLegendItem description={t('pyramidsView.shared.legend.forecast')} type="forecast" />
                {overview && (
                  <PyramidsLegendItem description={t('pyramidsView.shared.legend.recommended')} type="recommended" noMarginBottom />
                )}
              </PerFlexRow>
            </PerFlexRow>
            <PerFlexRow>
              <PerText appearance="info" mt="l" fontSize="s">
                {t(`pyramidsView.shared.legend.${activeTab === PyramidTabs.Level ? 'infoLevel' : 'infoAge'}`)}
              </PerText>
            </PerFlexRow>
          </BackgroundBox>
        </Col>
      </PerFlexRow>
    </BackgroundBox>
  )
}
